"use strict";

var _classCallCheck = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BNWrapper = void 0;

var bn_js_1 = __importDefault(require("bn.js"));

var BNWrapper = /*#__PURE__*/function (_bn_js_1$default) {
  _inherits(BNWrapper, _bn_js_1$default);

  var _super = _createSuper(BNWrapper);

  function BNWrapper() {
    _classCallCheck(this, BNWrapper);

    return _super.apply(this, arguments);
  }

  _createClass(BNWrapper, [{
    key: "max",
    value:
    /**
     * @description returns the maximum of 2 BN instances.
     */
    function max(other) {
      return this.from(bn_js_1.default.max(this, other));
    }
    /**
     * @description returns the minimum of 2 BN instances.
     */

  }, {
    key: "min",
    value: function min(other) {
      return this.from(bn_js_1.default.min(this, other));
    }
    /**
     * @description  clone number
     */

  }, {
    key: "clone",
    value: function clone() {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "clone", this).call(this));
    }
    /**
     * @description convert to two's complement representation, where width is bit width
     */

  }, {
    key: "toTwos",
    value: function toTwos(width) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "toTwos", this).call(this, width));
    }
    /**
     * @description  convert from two's complement representation, where width is the bit width
     */

  }, {
    key: "fromTwos",
    value: function fromTwos(width) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "fromTwos", this).call(this, width));
    }
    /**
     * @description negate sign
     */

  }, {
    key: "neg",
    value: function neg() {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "neg", this).call(this));
    }
    /**
     * @description negate sign
     */

  }, {
    key: "ineg",
    value: function ineg() {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "ineg", this).call(this));
    }
    /**
     * @description absolute value
     */

  }, {
    key: "abs",
    value: function abs() {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "abs", this).call(this));
    }
    /**
     * @description absolute value
     */

  }, {
    key: "iabs",
    value: function iabs() {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "iabs", this).call(this));
    }
    /**
     * @description addition
     */

  }, {
    key: "add",
    value: function add(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "add", this).call(this, b));
    }
    /**
     * @description  addition
     */

  }, {
    key: "iadd",
    value: function iadd(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "iadd", this).call(this, b));
    }
    /**
     * @description addition
     */

  }, {
    key: "addn",
    value: function addn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "addn", this).call(this, b));
    }
    /**
     * @description addition
     */

  }, {
    key: "iaddn",
    value: function iaddn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "iaddn", this).call(this, b));
    }
    /**
     * @description subtraction
     */

  }, {
    key: "sub",
    value: function sub(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "sub", this).call(this, b));
    }
    /**
     * @description subtraction
     */

  }, {
    key: "isub",
    value: function isub(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "isub", this).call(this, b));
    }
    /**
     * @description subtraction
     */

  }, {
    key: "subn",
    value: function subn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "subn", this).call(this, b));
    }
    /**
     * @description subtraction
     */

  }, {
    key: "isubn",
    value: function isubn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "isubn", this).call(this, b));
    }
    /**
     * @description multiply
     */

  }, {
    key: "mul",
    value: function mul(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "mul", this).call(this, b));
    }
    /**
     * @description multiply
     */

  }, {
    key: "imul",
    value: function imul(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "imul", this).call(this, b));
    }
    /**
     * @description multiply
     */

  }, {
    key: "muln",
    value: function muln(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "muln", this).call(this, b));
    }
    /**
     * @description multiply
     */

  }, {
    key: "imuln",
    value: function imuln(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "imuln", this).call(this, b));
    }
    /**
     * @description square
     */

  }, {
    key: "sqr",
    value: function sqr() {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "sqr", this).call(this));
    }
    /**
     * @description square
     */

  }, {
    key: "isqr",
    value: function isqr() {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "isqr", this).call(this));
    }
    /**
     * @description raise `a` to the power of `b`
     */

  }, {
    key: "pow",
    value: function pow(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "pow", this).call(this, b));
    }
    /**
     * @description divide
     */

  }, {
    key: "div",
    value: function div(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "div", this).call(this, b));
    }
    /**
     * @description divide
     */

  }, {
    key: "divn",
    value: function divn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "divn", this).call(this, b));
    }
    /**
     * @description divide
     */

  }, {
    key: "idivn",
    value: function idivn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "idivn", this).call(this, b));
    }
    /**
     * @description reduct
     */

  }, {
    key: "mod",
    value: function mod(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "mod", this).call(this, b));
    }
    /**
     * @description reduct
     */

  }, {
    key: "umod",
    value: function umod(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "umod", this).call(this, b));
    }
    /**
     * @description  rounded division
     */

  }, {
    key: "divRound",
    value: function divRound(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "divRound", this).call(this, b));
    }
    /**
     * @description or
     */

  }, {
    key: "or",
    value: function or(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "or", this).call(this, b));
    }
    /**
     * @description or
     */

  }, {
    key: "ior",
    value: function ior(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "ior", this).call(this, b));
    }
    /**
     * @description or
     */

  }, {
    key: "uor",
    value: function uor(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "uor", this).call(this, b));
    }
    /**
     * @description or
     */

  }, {
    key: "iuor",
    value: function iuor(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "iuor", this).call(this, b));
    }
    /**
     * @description and
     */

  }, {
    key: "and",
    value: function and(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "and", this).call(this, b));
    }
    /**
     * @description and
     */

  }, {
    key: "iand",
    value: function iand(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "iand", this).call(this, b));
    }
    /**
     * @description and
     */

  }, {
    key: "uand",
    value: function uand(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "uand", this).call(this, b));
    }
    /**
     * @description and
     */

  }, {
    key: "iuand",
    value: function iuand(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "iuand", this).call(this, b));
    }
    /**
     * @description and (NOTE: `andln` is going to be replaced with `andn` in future)
     */

  }, {
    key: "andln",
    value: function andln(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "andln", this).call(this, b));
    }
    /**
     * @description xor
     */

  }, {
    key: "xor",
    value: function xor(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "xor", this).call(this, b));
    }
    /**
     * @description xor
     */

  }, {
    key: "ixor",
    value: function ixor(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "ixor", this).call(this, b));
    }
    /**
     * @description xor
     */

  }, {
    key: "uxor",
    value: function uxor(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "uxor", this).call(this, b));
    }
    /**
     * @description xor
     */

  }, {
    key: "iuxor",
    value: function iuxor(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "iuxor", this).call(this, b));
    }
    /**
     * @description set specified bit to 1
     */

  }, {
    key: "setn",
    value: function setn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "setn", this).call(this, b));
    }
    /**
     * @description shift left
     */

  }, {
    key: "shln",
    value: function shln(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "shln", this).call(this, b));
    }
    /**
     * @description shift left
     */

  }, {
    key: "ishln",
    value: function ishln(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "ishln", this).call(this, b));
    }
    /**
     * @description shift left
     */

  }, {
    key: "ushln",
    value: function ushln(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "ushln", this).call(this, b));
    }
    /**
     * @description shift left
     */

  }, {
    key: "iushln",
    value: function iushln(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "iushln", this).call(this, b));
    }
    /**
     * @description shift right
     */

  }, {
    key: "shrn",
    value: function shrn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "shrn", this).call(this, b));
    }
    /**
     * @description shift right (unimplemented https://github.com/indutny/bn.js/blob/master/lib/bn.js#L2086)
     */

  }, {
    key: "ishrn",
    value: function ishrn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "ishrn", this).call(this, b));
    }
    /**
     * @description shift right
     */

  }, {
    key: "ushrn",
    value: function ushrn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "ushrn", this).call(this, b));
    }
    /**
     * @description shift right
     */

  }, {
    key: "iushrn",
    value: function iushrn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "iushrn", this).call(this, b));
    }
    /**
     * @description  test if specified bit is set
     */

  }, {
    key: "maskn",
    value: function maskn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "maskn", this).call(this, b));
    }
    /**
     * @description clear bits with indexes higher or equal to `b`
     */

  }, {
    key: "imaskn",
    value: function imaskn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "imaskn", this).call(this, b));
    }
    /**
     * @description add `1 << b` to the number
     */

  }, {
    key: "bincn",
    value: function bincn(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "bincn", this).call(this, b));
    }
    /**
     * @description not (for the width specified by `w`)
     */

  }, {
    key: "notn",
    value: function notn(w) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "notn", this).call(this, w));
    }
    /**
     * @description not (for the width specified by `w`)
     */

  }, {
    key: "inotn",
    value: function inotn(w) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "inotn", this).call(this, w));
    }
    /**
     * @description GCD
     */

  }, {
    key: "gcd",
    value: function gcd(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "gcd", this).call(this, b));
    }
    /**
     * @description Extended GCD results `({ a: ..., b: ..., gcd: ... })`
     */

  }, {
    key: "egcd",
    value: function egcd(bn) {
      var _get$call = _get(_getPrototypeOf(BNWrapper.prototype), "egcd", this).call(this, bn),
          a = _get$call.a,
          b = _get$call.b,
          gcd = _get$call.gcd;

      return {
        a: this.from(a),
        b: this.from(b),
        gcd: this.from(gcd)
      };
    }
    /**
     * @description inverse `a` modulo `b`
     */

  }, {
    key: "invm",
    value: function invm(b) {
      return this.from(_get(_getPrototypeOf(BNWrapper.prototype), "invm", this).call(this, b));
    }
    /**
     * Convert to BigInt type
     * @returns BigInt
     */

  }, {
    key: "toBigInt",
    value: function toBigInt() {
      return BigInt(this.toString());
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toString();
    }
  }, {
    key: "toString",
    value: function toString() {
      var base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var length = arguments.length > 1 ? arguments[1] : undefined;
      return _get(_getPrototypeOf(BNWrapper.prototype), "toString", this).call(this, base, length);
    }
  }]);

  return BNWrapper;
}(bn_js_1.default);

exports.BNWrapper = BNWrapper;